module.exports = "/images/vendor/desiigner-svg/svg/places/colosseum.svg?bd92079ac7feeec62fb7a72514d291d3";